import { EGender } from '@enums/Gender';
import formatterOnlyNumber from '@formatters/onlyNumbers';
import HttpClient from '@services/utils/HttpClient';

import { type ICreateCustomerInputData } from './dtos/createCustomer/InputData';
import { type IDeleteCustomerInputData } from './dtos/deleteCustomer/InputData';
import { type IUpdateCustomerInputData } from './dtos/updateCustomer/InputData';
import { type ICustomerRepository } from './ICustomerRepository';

interface ICreateBody {
  area_atuacao: number;
  celular: string;
  email: string;
  nome: string;
  senha: string;
}

interface IDeleteParams {
  id: number;
}

interface IUpdateParams {
  id: number;
}

interface IUpdateBody {
  ano_formacao: string;
  area_atuacao: number;
  avatar: string | null;
  celular: string;
  cidade_atua: string;
  documento: string;
  email: string;
  nome: string;
  pais_reside: string;
  sexo: EGender | null;
  uf_atua: string;
}

class CustomerService implements ICustomerRepository {
  public async create(inputData: ICreateCustomerInputData): Promise<void> {
    await HttpClient.post<unknown, ICreateBody>({
      path: 'cadastro.php',
      body: {
        celular: inputData.phone,
        email: inputData.email,
        nome: inputData.name,
        senha: inputData.password,
        area_atuacao: inputData.occupationAreaId,
      },
    });
  }

  public async delete(inputData: IDeleteCustomerInputData): Promise<void> {
    await HttpClient.delete<unknown, IDeleteParams>({
      path: 'usuarioexcluir.php',
      params: {
        id: inputData.id,
      },
    });
  }

  public async update(inputData: IUpdateCustomerInputData): Promise<void> {
    await HttpClient.put<unknown, IUpdateBody, IUpdateParams>({
      path: 'usuarios.php',
      body: {
        ano_formacao: inputData.yearGraduated,
        area_atuacao: inputData.occupationArea,
        avatar: inputData.picture,
        cidade_atua: inputData.occupationCity,
        uf_atua: inputData.occupationState,
        celular: formatterOnlyNumber(inputData.phone),
        email: inputData.email,
        nome: inputData.name,
        sexo: inputData.gender,
        documento: inputData.document,
        pais_reside: inputData.country,
      },
      params: {
        id: inputData.id,
      },
    });
  }
}

export default new CustomerService();
